import React, { useMemo } from "react";
import { Layout } from "../../layout/Layout.js";
import { FilterForm } from "../FilterForm.js";
import { useFilter } from "../FilterProvider.js";
import { MonthRows } from "./MonthEntries.js";
import { NewButton } from "../entry/NewButton.js";
import { groupByMonth } from "../../../model/accounting/entry/Entry.js";
import { Table } from "../../../../packages/ui/table/Table.js";
import { Link } from "../../../../packages/router/Link.js";
import { Buttons } from "../../../../packages/ui/form/Buttons.js";
import { useLoadEffect } from "../../../../react/load/useLoadEffect.js";
import { getEntries } from "../accountingApi.js";

/**
 * Shows the entries list page.
 */
export const EntriesPage = () => {
  const { year, month, titleSearch } = useFilter();

  const result = useLoadEffect(`entries-${year}-${month}`, () => getEntries(year, month));

  const entries = useMemo(() => (result.state === "success" ? result.data : []), [result]);

  const filteredEntries = useMemo(() => {
    const titleSearchLowerCase = titleSearch.toLowerCase();
    return entries.filter((entry) => entry.title.toLowerCase().includes(titleSearchLowerCase));
  }, [entries, titleSearch]);

  const months = useMemo(() => {
    return groupByMonth(filteredEntries);
  }, [filteredEntries]);

  return (
    <Layout title="Kirjed" containerWidth="fixed-wide-min">
      <h2>Kirjed</h2>
      <FilterForm />
      <Buttons>
        <NewButton />
        <Link to="/templates" className="button print-none">
          Vormid
        </Link>
      </Buttons>
      <Table fullWidth={true} fontSize="tiny" tableLayout="fixed">
        <thead>
          <tr>
            <th colSpan={1}>Kuupäev</th>
            <th colSpan={3}>Pealkiri</th>
            <th colSpan={1} className="text-right">
              Failid
            </th>
            <th colSpan={1} className="text-right">
              Tulud
            </th>
            <th colSpan={1} className="text-right">
              Kulud
            </th>
            <th colSpan={1} className="text-right">
              Varad
            </th>
            <th colSpan={1} className="text-right">
              Kohustused
            </th>
            <th colSpan={1} className="text-right">
              Sularaha
            </th>
          </tr>
        </thead>
        <tbody>
          {months.map((month) => (
            <MonthRows key={month.monthName} month={month} />
          ))}
        </tbody>
      </Table>
    </Layout>
  );
};
